import { getAllPermissions } from '../core/_requests';
import { useAuth } from '../core/Auth';
import { permissionManager } from '../core/PermissionManager';
import { useEffect, useState } from 'react';

export const usePermissions = () => {
  const { auth, currentUser } = useAuth();
  const [permissions, setPermissions] = useState<any>({});

  useEffect(() => {
    if (auth && currentUser?.token) {
      const decoded = permissionManager.decodeToken(currentUser.token);
      if (decoded) {
        // setPermissions(permissionManager.getAllPermissions());
        getPermissions()
      }
    } else {
      setPermissions({});
    }
  }, [auth, currentUser]);

  const getPermissions = async () => {
    try {
      const response = await getAllPermissions();
      setPermissions(response.data);
      
    } catch (error) {
      console.error('Failed to fetch permissions:', error);
    }
  }

  return {
    // Permissões individuais
    hasPermission: (permission: keyof any) => permissionManager.hasPermission(permission),
    hasAnyPermission: (permissions: (keyof any)[]) => permissionManager.hasAnyPermission(permissions),
    hasAllPermissions: (permissions: (keyof any)[]) => permissionManager.hasAllPermissions(permissions),
    
    // Permissões de acesso a módulos
    canAccessCursos: () => permissionManager.canAccessCursos(),
    canAccessTratamentos: () => permissionManager.canAccessTratamentos(),
    canAccessAssociados: () => permissionManager.canAccessAssociados(),
    canAccessDebitos: () => permissionManager.canAccessDebitos(),
    canAccessAgendamentos: () => permissionManager.canAccessAgendamentos(),
    canAccessRelatorios: () => permissionManager.canAccessRelatorios(),
    canAccessRelatoriosFinanceirosPage: () => permissionManager.canAccessRelatoriosFinanceirosPage(),
    canGenerateRelatoriosFinanceirosSetor: () => permissionManager.canGenerateRelatoriosFinanceirosSetor(),
    canGenerateRelatorioProcedimentoAberto: () => permissionManager.canGenerateRelatorioProcedimentoAberto(),
    
    // Permissões de gestão
    canManageCursos: () => permissionManager.canManageCursos(),
    canManageTratamentos: () => permissionManager.canManageTratamentos(),
    canManageDebitos: () => permissionManager.canManageDebitos(),
    canAccessOcorrencias: () => permissionManager.canAccessOcorrencias(),
    canManageOcorrencias: () => permissionManager.canManageOcorrencias(),
    
    // Roles
    // CURSOS
    isSuperAdmin: () => permissionManager.isSuperAdmin(),
    isAdmin: () => permissionManager.isAdmin(),
    isProfessor: () => permissionManager.isProfessor(),
    isOnlyProfessor: () => permissionManager.isOnlyProfessor(),
    notProfessor: () => permissionManager.notProfessor(),

    //TRATAMENTOS
    isAtendente: () => permissionManager.isAtendente(),

    //DEBITOS
    isAssociadoContato: () => permissionManager.isAssociadoContato(),
    
    // Dados do usuário
    getUserId: () => permissionManager.getUserId(),
    getUsername: () => permissionManager.getUsername(),
    
    // Todas as permissões
    getAllPermissions: () => permissions,
    
    // Status do token
    isTokenExpired: () => permissionManager.isTokenExpired(),
  };
}; 